module.exports = __webpack_public_path__ + "2cb40f9b13a2a7f3508ec177617b3104.png";